import {ActionReducerMap} from '@ngrx/store';

import * as fromAuth from './../auth/store/auth.reducers';
import * as fromError from './../error/store/error.reducers';
import * as fromUser from './../user/store/user.reducers';
import * as fromProfile from './../profile/store/profile.reducers';
import * as fromPayment from './../payment/store/payment.reducers';
import * as fromPost from './../profile/post/store/post.reducers';
import * as fromDemo from './../demo/store/demo.reducers';
import * as fromCertificate from './../profile/certificate/store/certificate.reducers';
import * as fromTrial from './../profile/trial/store/trial.reducers';
import * as fromCompare from './../compare/store/compare.reducers';
import * as fromSetting from './../setting/store/setting.reducers';
import * as fromSpecialOffer from './../special-offer/store/special-offer.reducers';

export interface AppState {
  auth: fromAuth.State;
  error: fromError.State;
  user: fromUser.State;
  profile: fromProfile.State;
  payment: fromPayment.State;
  post: fromPost.State;
  demo: fromDemo.State;
  certificate: fromCertificate.State;
  trial: fromTrial.State;
  compare: fromCompare.State;
  setting: fromSetting.State;
  specialOffer: fromSpecialOffer.State;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: fromAuth.authReducer,
  error: fromError.errorReducer,
  user: fromUser.userReducer,
  profile: fromProfile.profileReducer,
  payment: fromPayment.paymentReducer,
  post: fromPost.postReducer,
  demo: fromDemo.demoReducer,
  certificate: fromCertificate.certificateReducer,
  trial: fromTrial.trialReducer,
  compare: fromCompare.compareReducer,
  setting: fromSetting.settingReducer,
  specialOffer: fromSpecialOffer.specialOfferReducer
};
